export const mockedKpiToMetricMap: Record<string, string> = {
  Acquisition: "CPA (Cost-Per-Acquisition)",
  "App Event": "CPAE (Cost-per-app event)",
  "App Install": "CPI (Cost-Per-Install)",
  Booking: "CPB (Cost-Per-Booking)",
  Engagement: "CPE (Cost-Per-Engagement)",
  "Event Response": "CPER (Cost-per-event response)",
  Impression: "CPM (Cost-Per-Million Impressions)",
  "Intent Action": "CPIA (Cost-per-Intent Actions)",
  "Landing Page Visit": "CPLV (Cost-Per-Landing Page View)",
  "Lead Gen": "CPL (Cost-Per Lead)",
  "Link Click": "CPLC (Cost-per-link click)",
  "Local Action": "CPLA (Cost-per-local action)",
  "Page Like": "CPPL (Cost-Per-Page Like)",
  Purchase: "CPP (Cost-Per-Purchase)",
  ROAS: "ROAS (Return-on-ad-spend)",
  "Store Visit": "CPSV (Cost-per-store visit)",
  "Submission / Entry": "CPS (Cost-per-submission)",
  "Video View": "CPCV (Cost-Per-Completed View)",
  "Website Action": "CPSA (Cost-per-site action)",
};

export const mockedKPIs: string[] = [
  "Acquisition",
  "App Event",
  "App Install",
  "Booking",
  "Engagement",
  "Event Response",
  "Impression",
  "Intent Action",
  "Landing Page Visit",
  "Lead Gen",
  "Link Click",
  "Local Action",
  "Page Like",
  "Purchase",
  "ROAS",
  "Store Visit",
  "Submission / Entry",
  "Video View",
  "Website Action",
];

export const campaignKpiPlanningStageMapping = {
  Acquisition: "Conversion",
  "App Event": "Conversion",
  "App Install": "Conversion",
  Booking: "Conversion",
  Engagement: "Consideration",
  "Event Response": "Conversion",
  Impression: "Awareness",
  "Intent Action": "Conversion",
  "Landing Page Visit": "Consideration",
  "Lead Gen": "Conversion",
  "Link Click": "Consideration",
  "Local Action": "Conversion",
  "Page Like": "Consideration",
  Purchase: "Conversion",
  ROAS: "Conversion",
  "Store Visit": "Conversion",
  "Submission / Entry": "Conversion",
  "Video View": "Consideration",
  "Website Action": "Conversion",
} as const;

export const channelObjectiveMap = {
  "Connected TV": "Awareness",
  Radio: "Awareness",
  Meta: "Store Visit",
  OOH: "Awareness",
  Print: "Awareness",
  "Bing Shopping": "Conversion",
  Display: "Conversion",
  "Streaming Audio": "Awareness",
  YouTube: "Impression",
  Email: "Awareness",
  Snapchat: "Awareness",
  Native: "Awareness",
  "Online Video": "Awareness",
  "Google Demand Gen": "Conversion",
  "Google App": "App Install",
  "Digital OOH": "Awareness",
  "Google Search": "Conversion",
  Pinterest: "Conversion",
  Television: "Awareness",
  "Direct Mail": "Conversion",
  Target: "Conversion",
  X: "Post Engagement",
  DRTV: "Awareness",
  "Content Syndication": "Lead Gen",
  LinkedIn: "Awareness",
  "Apple Search": "App Install",
  Reddit: "Conversion",
  "Google Pmax": "Conversion",
  TikTok: "Traffic",
  "Custom Article": "Awareness",
  Albertson: "Sponsored Product",
  GoPuff: "Sponsored Product",
  "Macy's": "Sponsored Product",
  Amazon: "Sponsored Display",
  "Google PMax": "Store Visit",
  Podcast: "Awareness",
  "Television Time + Temp": "Awareness",
  Shipt: "Sponsored Product",
  Walgreens: "Sponsored Product",
  "Kohl's": "Sponsored Product",
  Wayfair: "Sponsored Product",
  "Custom Article Traffic Driver": "Awareness",
  Nextdoor: "Awareness",
  Flipboard: "Traffic",
  Yelp: "Awareness",
  Walmart: "Sponsored Product",
  Instacart: "Sponsored Product",
  Kroger: "Sponsored Product",
  CVS: "Sponsored Product",
  "Google Local Services Ads": "Conversion",
  "Bing Search": "Awareness",
  Indeed: "Conversion",
  Meijer: "Sponsored Product",
  "Branded Article": "Awareness",
  "Google Shopping": "Conversion",
  "Google Search Grants": "Traffic",
} as const;
